import { ZoomAppSettings } from "./ZoomAppSettings";

export default ZoomAppSettings;
